import React from "react";
import { Container, Typography } from "@mui/material";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#123A8A",
        padding: "40px 0",
        color: "#fff",
        marginTop: "40px",
      }}
    >
      <Container>
        <Typography variant="body1" align="center">
          © {new Date().getFullYear()} FC Zinguería. Todos los derechos
          reservados.
        </Typography>
      </Container>
    </footer>
  );
};

export default Footer;
